import styled from "styled-components";
import { colors } from "@/theme";

export const CartProductItemContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  column-gap: 16px;
`;

export const CartProductItemImageContainer = styled.div`
  display: flex;
  width: 76px;
  height: 73px;
  padding: 4px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 12px;
  background: transparent;

  & img {
    width: 60px;
    height: 60px;
    flex-shrink: 0;
  }
`;

export const CartProductItemInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-self: center;
`;

export const CartProductItemInfoTitle = styled.div`
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  margin: 0;
`;

export const CartProductItemInfoSku = styled.div`
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin: 0;
`;
